import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';

import j from '../assets/images/j.jpg'

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={j} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/jadamswalton" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/jadamswalton/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>J. Adams Walton</h1>
          <p>Full Stack Development | Data Science & Architecture | Digital Forensics</p>
          <h4>I am a deeply curious and introspective individual, drawn to both the grandeur of cosmic questions and the fine details of everyday systems. My interests span prime number theory, the Fermi Paradox, classic science fiction, World War I history, and advanced technologies like AI and full-stack development. Whether I’m pondering humanity’s place in the universe, refining data architectures, or training in Kali Escrima, I strive to challenge myself and expand my understanding of the world. This broad-ranging passion reflects my belief that intellectual exploration, historical context, creative thinking, and disciplined practice are all interconnected pathways to growth and insight.</h4>

          <div className="mobile_social_icons">
            <a href="https://github.com/jadamswalton" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/jadamswalton/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;